import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { CALCULATE_ENERGY_PER_LOT } from '../../../graphql/auctions';
import { createErrorMessages } from '../../errors/Errors';
import Number from '../../Number';
import Spinner from '../../Spinner';
import { joinClassNames } from '../../../utils';

AuctionEnergyPerLot.propTypes = {
    deliveryYear: PropTypes.string.isRequired,
    productId: PropTypes.string.isRequired,
    power: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    quantityUnit: PropTypes.node.isRequired,
    className: PropTypes.string,
};

AuctionEnergyPerLot.defaultProps = {
    className: '',
};

function AuctionEnergyPerLot(props) {
    const {
        deliveryYear,
        productId,
        power,
        label,
        quantityUnit,
        className,
    } = props;
    const { t } = useTranslation();
    const [errorMessage, setErrorMessage] = useState(null);
    const errorHandler = (err) => {
        setErrorMessage(createErrorMessages(err).join(', '));
    };
    const { loading, error, data } = useQuery(CALCULATE_ENERGY_PER_LOT, {
        variables: {
            year: deliveryYear,
            productId,
            power,
        },
        onCompleted: (_) => setErrorMessage(null),
        onError: errorHandler,
        fetchPolicy: 'network-only',
    });
    let energyPerLot;
    if (loading) {
        energyPerLot = <Spinner className="auction-energy-per-lot--loading" displayLabel={false} size={5} />;
    } else if (error) {
        energyPerLot = t('auctions.auction-setup.na');
    } else {
        energyPerLot = <Number value={data.calculateEnergyPerLot} />;
    }
    return (
        <div className={joinClassNames('field', 'readonly', className, errorMessage && 'error')}>
            <span className="field--key">{label}</span>
            <div className="field--value">{energyPerLot}{quantityUnit}</div>
            {errorMessage && <div className="validation-error">{errorMessage}</div>}
        </div>
    );
}

export default AuctionEnergyPerLot;
